import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const LinkField: FC<Props> = ({ index, onBlur, onChange }) => {
  const { t } = useTranslation();

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout>
      <FormInput
        name={`websites.${index}.websiteType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`websites.${index}.websiteAddress`}
        placeholder="website.com"
        onBlur={handleBlur}
      />
    </FieldLayout>
  );
};
